import {
    APP,
} from '_pixiSrc/globals';
import { MOBILE } from '_pixiSrc/layout/features';
import Sprite from '_pixiSrc/display/Sprite';
import Static from '../libraries/Static';
import GameConfig from '../libraries/GameConfig';
import NetworkController from '../network/NetworkController';
import GameData from '../ui/GameData';
import AudioManager from '../ui/AudioManager';
import PayoutsPopup from '../ui/PayoutsPopup';
import DynamicData from '../ui/DynamicData';
import { GAME_PROPERTY_KEY } from '../Constants';

let index = 0;
const wheels = [];
let isStopPressed = false;
const symbolAssets = [
    'game/icons/Low_10_symbol',
    'game/icons/Low_J_symbol',
    'game/icons/Low_Q_symbol',
    'game/icons/Low_K_symbol',
    'game/icons/Low_A_symbol',
    'game/icons/Hi_05',
    'game/icons/Hi_04',
    'game/icons/Hi_03',
    'game/icons/Hi_02', [
        ['game/icons/Hi_01'],
        ['game/icons/Hi_01_1_free', 'game/icons/Hi_01_2_free'],
    ],
];
const anticipation = [
    'anticipation/anticipation',
];
const expandingSymbolAssets = [
    'expanding/Low_10_symbol',
    'expanding/Low_J_symbol',
    'expanding/Low_Q_symbol',
    'expanding/Low_K_symbol',
    'expanding/Low_A_symbol',
    'expanding/Hi_05',
    'expanding/Hi_04',
    'expanding/Hi_03',
    'expanding/Hi_02',
];
let stopCallback;
let lastResult;
let anticipationSprite = {};
let scatterCount = 0;
let sactterTime = 0;
let shownAticipationAnimation = false;

let finalPositions = []; // final results received from the server

let currentExpandingSprites = [];
let currentExpandingTimers = [];
let expandingCallback;
let expandingSymbols;


let noofWheelsStopped = 0;

/**
 * @class Wheel
 * Wheel class manage reels data and reels animation
 */
class Wheel extends Sprite {
    /* STATIC METHODS GENERAL FOR ALL WHEELS */

    /**
   * @name tick
   * @param e
   * @description rotation, hang on teak
   */
    static tick(e) {
        wheels.forEach((wheel) => {
            wheel._rotateWheel(e.delta);
        });
    }

    /**
   * @name rotateWheels
   * @description start rotation
   */
    static rotateWheels(callback) {
        if (wheels.some(e => !e.isStopped)) { return; }
        isStopPressed = false;

        wheels.forEach((wheel) => {
            wheel.start();
        });

        stopCallback = callback;
        noofWheelsStopped = 0;

        finalPositions = [];
        const anticipation = [];
        const beforResponse = new Date();
        NetworkController.getSpinResult((res) => {
            const afterResponse = new Date();
            if (afterResponse - beforResponse < GameConfig.wheelRotationTime[2]) {
                shownAticipationAnimation = true;
            } else {
                shownAticipationAnimation = false;
            }

            /**
      * set final position which comes from server
      */
            finalPositions = res;

            /**
      * set array for show Aticipation animation in reel
      * if true than show animation
      */
            finalPositions.map((item, index) => {
                if (sactterTime >= 2) {
                    anticipation.push(true);
                } else {
                    anticipation.push(false);
                }
                item.map((i) => {
                    if (i === 9) {
                        sactterTime++;
                    }
                });
            });

            /**
      * change stop time of reels
      */
            if (sactterTime >= 2 && shownAticipationAnimation) {
                let time = 0;
                wheels.forEach((wheel, index) => {
                    if (anticipation[index]) {
                        time++;
                        wheel.changeStopTime(time);
                    }
                });
            }
        });
        NetworkController.getExpandingWheels(res => res.forEach((e, ind) => {
            if (e === 1) { wheels[ind].isExpanding = true; }
        }));
    }

    stopWheelSpin() {
        clearTimeout(this.timer);

        const time = Wheel._isTurbo() ? GameConfig.wheelTurboTime[this.wheelIndex] : GameConfig.wheelRotationTime[this.wheelIndex];

        this.timer = setTimeout(() => {
            this.finalMove();
        }, time);
    }

    /**
   * @name stopWheels
   * @description stop rotation
   */
    static stopWheels(callback) {
        if (isStopPressed) {
            return;
        } // protection from double-clicking a button
        isStopPressed = true;

        stopCallback = callback;

        wheels.forEach((wheel) => {
            wheel.defferedStop();
        });
    }

    /**
   * @name init
   * @param positionNumber
   * @description sets the starting position of all wheels according to the configuration data
   */
    static init(positionNumber = 0) {
        wheels.forEach((wheel) => {
            wheel.symbols = GameConfig.wheelStartingPositions[positionNumber][wheel.wheelIndex].slice();
            wheel.stopWheel();
        });
    }

    static countResult() {
        const result = [];

        wheels.forEach((wheel) => {
            result.push(wheel.symbols.slice(1));
        });

        lastResult = result;
        return result;
    }

    static runCallback() {
        noofWheelsStopped++;
        if (noofWheelsStopped < 5) { return; }

        if (stopCallback) {
            const result = Wheel.countResult();
            stopCallback(result);
        }
    }

    /**
   * @name animateSymbols
   * @param inputArr
   * @param speedMultiplier
   * @description show symbol animation
   */
    static animateSymbols(inputArr, speedMultiplier = 1) {
        wheels.forEach(wheel => wheel.animateSymbols(inputArr, speedMultiplier));
    }

    /**
   * @name startAnimateSymbols
   * @param inputArr
   * @description show winning symbol animation
   */
    static startAnimateSymbols(inputArr) {
        wheels.forEach(wheel => wheel.startAnimateSymbols(inputArr));
    }

    /**
   * @name animateScatters
   * @param response
   * @description show scatter animation on free Spin
   */
    static animateScatters(response) {
        const durationMultiplier = 1000 / GameConfig.singleLineAnimationDuration;
        let isFirst = true;

        function animateSprite(sprite, callback) {
            sprite.animationSpeed = (sprite.totalFrames / 60) * durationMultiplier;
            sprite.on('animationend', function () {
                this.stop();
                if (callback) { callback(); }
            });
            sprite.play();
        }

        wheels.forEach((wheel) => {
            wheel.symbols.forEach((s, i) => {
                if (s === 9) {
                    animateSprite(wheel.sprites[i], isFirst ? response : null);
                    isFirst = false;
                }
            });
        });
    }

    /**
   * @name expandSymbols
   * @description expand expanding symbols
   */
    static expandSymbols(callback, symbols = []) {
        expandingCallback = callback;
        expandingSymbols = symbols;
        (function expand(counter) {
            const obj = symbols[counter];

            if (!obj) {
                if (expandingCallback) { expandingCallback(); }
                expandingCallback = null;
                return;
            }
            if (Wheel._isTurbo()) {
                if (symbols[counter + 1]) {
                    wheels[obj.wheelN].expandSymbol(obj.symbolN, obj.newSymbol, null, obj.animSpeed);
                    expand(counter + 1);
                } else {
                    wheels[obj.wheelN].expandSymbol(obj.symbolN, obj.newSymbol, () => {
                        currentExpandingTimers.push(setTimeout(() => expand(counter + 1), 500));
                    }, obj.animSpeed);
                }
            } else if ((symbols[counter + 1] && symbols[counter + 1].wheelN === obj.wheelN)) {
                wheels[obj.wheelN].expandSymbol(obj.symbolN, obj.newSymbol, null, obj.animSpeed);
                currentExpandingTimers.push(setTimeout(() => expand(counter + 1), 200));
            } else {
                wheels[obj.wheelN].expandSymbol(obj.symbolN, obj.newSymbol, () => {
                    expand(counter + 1);
                }, obj.animSpeed);
            }
            AudioManager.playSound('fx', 'expanding_v3');
        }(0));
    }

    /**
   * @name stopExpanding
   * @description stopn expand expanding symbols
   */
    static stopExpanding() {
        if (currentExpandingSprites && expandingCallback) {
            currentExpandingSprites.forEach(e => e.safeRemove());
            currentExpandingSprites = [];
            currentExpandingTimers.forEach(e => clearTimeout(e));
            currentExpandingTimers = [];
            expandingSymbols.forEach(e => wheels[e.wheelN].symbols[e.symbolN] = e.newSymbol);
            wheels.forEach(e => e._setView());

            expandingCallback();
            expandingCallback = null;
            return true;
        }
    }

    static refreshView() {
        wheels.forEach(e => e._setView());
    }

    static get lastResult() {
        return Wheel.countResult();
    }

    static _isTurbo() {
        // if (MOBILE && GameData.getProperty('isAutospin')) {
        //   return GameData.getProperty('isAutoTurboChecked');
        // }
        return GameData.getProperty('isTurboChecked');
    }

    constructor(x, y) {
        super();

        this.x = x;
        this.y = y;

        this.isStopped = true; // flag indicating whether the wheel is stopped
        this.timer = null; // stop timer
        this.shifted = 0;

        this.wheelIndex = index++;

        this.symbols = [0, 0, 0, 0];
        this.sprites = [];

        this.spaceBetweenSymbols = 120;

        this.isExpanding = false;

        this.isFinishing = false; // flag indicating that the rotation of the wheel is completed
        this.finishingStep = 0; // counter showing the current character to be read

        wheels.push(this);
    }

    /**
   * @name start
   * @description start spinnig
   */
    start() {
        this._setView();

        this.isFinishing = false;
        this.finishingStep = 0;
        this.isStopped = false;
        this.shifted = 0;

        const time = Wheel._isTurbo() ? GameConfig.wheelTurboTime[this.wheelIndex] : GameConfig.wheelRotationTime[this.wheelIndex];

        this.timer = setTimeout(() => {
            this.finalMove();
        }, time);

        this.isExpanding = false;
    }

    /**
   * @name defferedStop
   * @description delayed stop, is called when the button is pressed
   */
    defferedStop() {
        clearTimeout(this.timer);

        this.timer = setTimeout(() => {
            this.finalMove();
        }, GameConfig.wheelImmediateStopTime[this.wheelIndex]);
    }

    finalMove() {
        this.isFinishing = true;
    }

    /**
   * @name stopWheel
   * @description stop spinnig wheel
   */
    stopWheel(isBounce = false) {
        this._setView();
        this.shifted = 0;

        if (finalPositions[this.wheelIndex]) {
            finalPositions[this.wheelIndex].map((i) => {
                if (i === 9) {
                    scatterCount++;
                }
            });
        }

        this.isStopped = true;
        if (this.wheelIndex >= 1 && this.wheelIndex < 4 && scatterCount >= 2 && shownAticipationAnimation) {
            this.showAnticipate();
            this.removeAnticipate(this.wheelIndex);
        }
        if (this.wheelIndex === 4) {
            this.removeAllAnticipate();
        }
        if (isBounce) {
            this.finalBounce(() => {
                if (stopCallback) { Wheel.runCallback(); }
            });
        } else if (stopCallback) { Wheel.runCallback(); }

        this.addPopupListeners(); // after the stop, add all the sprites to the crawler for a click with a pop
    }

    /**
   * @name changeStopTime
   * @description change stop time of reel
   */
    changeStopTime(counter) {
        clearTimeout(this.timer);

        let time = Wheel._isTurbo() ? GameConfig.wheelTurboTime[this.wheelIndex] : GameConfig.wheelRotationTime[this.wheelIndex];
        if (sactterTime >= 2) {
            time += counter * 500;
        }

        this.timer = setTimeout(() => {
            this.isFinishing = true;
        }, time);
    }

    /**
   * @name showAnticipate
   * @description show anticipate animation
   */
    showAnticipate() {
        const temp = wheels[this.wheelIndex + 1];
        const container = temp.addChild(new Sprite());
        container.position.set(0, 240);
        const anticipate = anticipation.map(e => APP.library.getAsset(e));
        const anticipateSPR = new Sprite(anticipate);
        anticipateSPR.animationSpeed = 0.8;
        container.addChild(anticipateSPR);
        anticipationSprite[`id_${this.wheelIndex + 1}`] = anticipateSPR;
    }

    /**
   * @name removeAnticipate
   * @param id
   * @description remove sprite animation
   */
    removeAnticipate(id) {
        if (anticipationSprite[`id_${id}`]) {
            anticipationSprite[`id_${id}`].parent.safeRemove();
        }
    }

    /**
   * @name removeAllAnticipate
   * @description remove sprite animation
   */
    removeAllAnticipate() {
        for (const key in anticipationSprite) {
            if (anticipationSprite.hasOwnProperty(key) && anticipationSprite[key].parent) {
                anticipationSprite[key].parent.safeRemove();
            }
        }
        scatterCount = 0;
        sactterTime = 0;
        anticipationSprite = {};
    }

    /**
   * @name addPopupListeners
   * @description add all the sprites to the crawler for a click with a pop
   */
    addPopupListeners() {
        for (let i = 1; i < this.sprites.length; i++) {
            this.sprites[i].on('pointerclick', () => PayoutsPopup.invoke(this.parent, this.symbols[i]));
        }
    }

    /* ANIMATIONS */

    /**
   * @name expandSymbol
   * @param symbolNum
   * @param symbolType
   * @param onFinish
   * @param animationSpeed
   * @description expanding symbol animation
   */
    expandSymbol(symbolNum, symbolType, onFinish, animationSpeed = 0.4) {
        this.isExpanding = true;

        const sprite = this.sprites[symbolNum];
        this.symbols[symbolNum] = symbolType;

        const animation = this.addChild(APP.library.getSprite('game/change_symbol_anim'));
        animation.position.set(sprite.parent.x, sprite.parent.y);
        animation.zIndex = 100;
        const totalFrames = animation.textures.length;
        const frameDuration = 1000 / (animationSpeed * 60);
        const animDuration = frameDuration * totalFrames;

        animation.animationSpeed = animationSpeed;
        animation.on('changeframe', (e) => {
            if (e.frame === 7) {
                if (onFinish) { onFinish(); }
            }
            if (e.frame === 10) {
                this._setView();
                const view = this.sprites[symbolNum];
                view.alpha = 0.5;
                view.fadeTo(1, animDuration / 2);
            }
            if (e.frame === 19) {
                animation.safeRemove();
            }
        });

        sprite.fadeTo(0, animDuration / 2, null, () => sprite.visible = false);
        const tmp = this._addSprite(symbolNum, 0);
        tmp.alpha = 0;
        tmp.fadeTo(0.5, animDuration / 2);

        currentExpandingSprites.push(animation);
    }

    startAnimateSymbols(input) {
        const resultSymbolsIndexes = [];

        this.symbols.slice(1).forEach((e, ind) => {
            if (input[this.wheelIndex][ind] === 1) {
                resultSymbolsIndexes.push(ind + 1);
            }
        });

        for (let i = 0; i < resultSymbolsIndexes.length; i++) {
            const sprite = this.sprites[resultSymbolsIndexes[i]];

            sprite.play();
        }
    }

    animateSymbols(input, speedMultiplier = 1) {
        const resultSymbolsIndexes = [];
        const durationMultiplier = 1000 / GameConfig.singleLineAnimationDuration;

        this.symbols.slice(1).forEach((e, ind) => {
            if (input[this.wheelIndex][ind] === 1) {
                resultSymbolsIndexes.push(ind + 1);
            }
        });

        for (let i = 0; i < resultSymbolsIndexes.length; i++) {
            const sprite = this.sprites[resultSymbolsIndexes[i]];

            animateSprite(sprite);
            animateFrame(sprite.burningFrame);
        }

        function controlFrameAnimation(e) {
            if (e.frame === e.target._stopFrame) {
                e.target.off('changeframe', controlFrameAnimation);
                e.target._stopFrame = undefined;
                e.target.gotoAndStop(0);
            }
        }

        function animateSprite(sprite) {
            sprite.animationSpeed = (sprite.totalFrames / 60) * durationMultiplier;

            if (speedMultiplier > 1) {
                sprite.play();
            } else {
                sprite._stopFrame = undefined;
                sprite.off('changeframe', controlFrameAnimation);
                sprite.gotoAndPlay(0);

                sprite.once('animationend', function () {
                    this.gotoAndStop(0);
                });
            }
        }

        function animateFrame(sprite) {
            sprite.animationSpeed = (sprite.totalFrames / 60) * durationMultiplier;
            sprite.once('animationend', function () {
                this.gotoAndStop(0);
            });

            if (speedMultiplier > 1) {
                sprite._stopFrame = 11;
                sprite.on('changeframe', controlFrameAnimation);
                sprite.gotoAndPlay(6);
            } else {
                sprite._stopFrame = undefined;
                sprite.off('changeframe', controlFrameAnimation);
                sprite.gotoAndPlay(0);
            }
        }
    }

    /* INTERNAL METHODS */

    /**
   * @name _rotateWheel
   * @description It generates a new array of symbols each tick
   */
    _rotateWheel(delta) {
        if (delta > 100) { delta = 100; }
        if (this.isStopped) { return; }

        let speed = GameConfig.wheelRollingSpeed;

        if ((isStopPressed || Wheel._isTurbo()) && finalPositions.length > 0) {
            speed *= 3;
        }

        if (scatterCount >= 2) {
            speed = GameConfig.wheelRollingSpeed + 7;
        }

        const shiftY = speed * delta / 10;

        this._changeSymbolsPositions(shiftY);

        this.shifted += shiftY;
        if (this.shifted > this.spaceBetweenSymbols) {
            this._changeSymbol(this.shifted);
            this.shifted = this.shifted - this.spaceBetweenSymbols;
        }
    }

    /**
   * @name _changeSymbolsPositions
   * @description shifts the positions of each character down
   */
    _changeSymbolsPositions(shiftY) {
        for (let i = 0; i < this.sprites.length; i++) {
            this.sprites[i].parent.y += shiftY;
        }
    }

    /**
   * @name _changeSymbol
   * @description changes the symbol in the wheel every n-th frame
   */
    _changeSymbol(shifted) {
        const createRandomSymbol = () => {
            let random = Static.randomInteger(0, 999) / 10;
            let newIndex = -1;

            while (random >= 0) {
                newIndex++;
                random -= GameConfig.symbolChance[newIndex][this.wheelIndex];
            }

            return newIndex;
        };

        let newIndex;

        if (this.isFinishing && finalPositions.length) {
            if (this.finishingStep < 3) {
                newIndex = finalPositions[this.wheelIndex][2 - this.finishingStep];
                this.finishingStep++;
            } else if (this.finishingStep == 3) {
                newIndex = createRandomSymbol();
                this.finishingStep++;
                if (!Wheel._isTurbo() && !isStopPressed) {
                    AudioManager.playSound('fx', 'reels_stop');
                } else if (this.wheelIndex === 4) {
                    AudioManager.playSound('fx', 'reels_stop');
                }
            }
        } else {
            newIndex = createRandomSymbol();
        }

        this.symbols.pop();
        this.symbols.unshift(newIndex);

        this._refreshView(shifted);
        if (this.finishingStep > 3) {
            this.stopWheel(GameConfig.isFinalBounce);
            this.finishingStep++;
        }
    }

    /**
   * @name _setView
   * @description set all the sprites in the reels according to the current viewZone
   */
    _setView(shift = 0) {
        this.sprites.forEach((e, ind) => {
            this._removeSprite(ind);
        });

        for (let i = 0; i < this.symbols.length; i++) {
            this._addSprite(i, shift);
        }
    }

    /**
   * @name _refreshView
   * @description updates the image of the symbols after generating a new table
   */
    _refreshView(shift = 0) {
        for (let i = 0; i < this.symbols.length; i++) {
            this.sprites[i].y -= shift;
        }
        this._setView(shift - this.spaceBetweenSymbols);
    }

    _addSprite(i, shift) {
        const container = this.addChild(new Sprite());
        container.position.set(0, i * this.spaceBetweenSymbols + shift);


        let src = (this.isExpanding && this.finishingStep > 1 && this.symbols[i] === GameData.getProperty('expandingSymbol'))
            ? expandingSymbolAssets[this.symbols[i]]
            : symbolAssets[this.symbols[i]];

        let asset;

        if (Array.isArray(src)) {
            (GameData.getProperty('isFreeGame') && DynamicData.getValue('FGCounter') === 0) ? src = src[1] : src = src[0];
            asset = src.map(e => APP.library.getAsset(e));
        } else {
            asset = APP.library.getAsset(src);
        }
        const spr = new Sprite(asset);

        spr.gotoAndStop(0);
        container.addChild(spr);
        this.sprites[i] = spr;

        spr.burningFrame = container.addChild(APP.library.getSprite('game/burning_frame_anim'));
        spr.burningFrame.y = 7;
        spr.burningFrame.gotoAndStop(0);

        this.correctSpritePosition(spr, this.symbols[i], this.symbols[i] === GameData.getProperty('expandingSymbol'));

        return spr;
    }

    correctSpritePosition(sprite, spriteNumber, isExpanding) {
        if (isExpanding) { sprite.y = -8; }
        switch (spriteNumber) {
            case 0:
                if (!this.isExpanding) { sprite.y = -1; }
                break;
            case 2:
                if (!this.isExpanding) { sprite.y = -1; }
                break;
            case 4:
                if (!this.isExpanding) { sprite.y = 4; }
                break;
            case 5:
            case 6:
                if (!this.isExpanding) {
                    sprite.y = 2;
                }
                break;
            case 7:
                if (!this.isExpanding) {
                    sprite.x = -2;
                    sprite.y = -1;
                }
                break;
            case 8:
                if (!this.isExpanding) {
                    sprite.y = 1;
                }
                break;
            case 9:
                sprite.y = -3;
                if (GameData.getProperty('isFreeGame') && DynamicData.getValue('FGCounter') === 0) {
                    sprite.y = -15;
                }
                sprite.x = -2;
                break;
        }
    }

    finalBounce(callback) {
        this.moveBy(0, GameConfig.finalBounceForce, GameConfig.finalBounceDuration, null, () => {
            this.moveBy(0, -GameConfig.finalBounceForce, GameConfig.finalBounceDuration, null, () => {
                if (callback) { callback(); }
            });
        });
    }

    _removeSprite(i) {
        this.sprites[i].parent.safeRemove();
    }
}

export default Wheel;
